import { AnalisisMethod } from '../interfaces/treatment';

export class MAnalisisMethod{
    public id: number;
    public name: string;

    constructor(method: AnalisisMethod){
        this.id = method.id;
        this.name = method.nombre
    }
}